import { CommitmentClassTabProps } from "features/commitment-classes/setup/CommitmentClassTabProps";
import FeeTable, { FeeTableGetFeeEditPathFn } from "features/fees/FeeTable";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { PageInstructions } from "shared/components/layout/PageInstructions";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentClassTabFees: React.FC = () => {
  const { t } = useTranslation(["commitmentClass"]);
  const { fundFamilyId, investorClassId } =
    useOutletContext<CommitmentClassTabProps>();

  const getFeeEditPath = useCallback<FeeTableGetFeeEditPathFn>(
    (feeId) =>
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .setup({})
        .classes({})
        .fee({ investorClassId, feeId }).$,
    [fundFamilyId, investorClassId],
  );

  return (
    <PageTabBody>
      <PageInstructions>{t("commitmentClass:instructions")}</PageInstructions>
      <FeeTable
        fundFamilyId={fundFamilyId}
        retrieveParams={{ investor_class_id: investorClassId }}
        getFeeEditPath={getFeeEditPath}
      />
    </PageTabBody>
  );
};
